'use client'

import { useState } from 'react'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useSession } from '@marketplace-web/shared/session-data'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import { ConversationActionProps } from '@marketplace-web/messaging/conversation-action-data'
import { ConversationActionButton } from '@marketplace-web/messaging/conversation-action-feature'

import BalanceActivationModal from '../BalanceActivationModal'

type Props = ConversationActionProps

const ActivateBalance = ({ primary, title, inverse, theme, size }: Props) => {
  const translate = useTranslate('conversation.actions.activate_balance')

  const { conversation, getConversationRequest } = useConversationContext()
  const { user } = useSession()

  const currentUserId = user?.id

  const [isModalVisible, setIsModalVisible] = useState(false)

  const handleClick = () => setIsModalVisible(true)

  const hideActivateBalanceModal = () => {
    setIsModalVisible(false)
  }

  const handleBalanceActivated = () => {
    setIsModalVisible(false)

    if (!conversation?.id || !currentUserId) return

    getConversationRequest({ conversationId: conversation.id })
  }

  const renderModal = () => {
    const labels = {
      title: translate('title'),
      description: translate('description'),
    }

    if (!isModalVisible) return null

    return (
      <BalanceActivationModal
        labels={labels}
        isOpen={isModalVisible}
        onSuccess={handleBalanceActivated}
        onCancel={hideActivateBalanceModal}
      />
    )
  }

  const renderActionButton = () => (
    <ConversationActionButton
      text={title}
      primary={primary}
      size={size}
      theme={theme}
      inverse={inverse}
      onClick={handleClick}
    />
  )

  return (
    <>
      {renderActionButton()}
      {renderModal()}
    </>
  )
}

export default ActivateBalance
